import {APP_WEBVIEW_COOKIE_NAME, APP_WEBVIEW_PLATFORMS} from '~/conf/app';

/**
 * Detects whether we're running inside one of the native FOREVER app's webviews.
 *
 * Mirrors forever-ui's own `plugins/webviews.js` mechanism verbatim: the native app sets an
 * `fv_platform` cookie to `ios` or `android` before loading us, and any other value (or no cookie
 * at all) means a regular browser. Reading it through `useCookie` keeps SSR and the client in
 * agreement, so webview-only markup differences don't cause hydration mismatches.
 */
export function useWebView() {
  const cookie = useCookie(APP_WEBVIEW_COOKIE_NAME);

  const platform = computed(() => (
    Object.values(APP_WEBVIEW_PLATFORMS).includes(cookie.value) ? cookie.value : null
  ));

  return {
    platform,
    isAppWebView: computed(() => Boolean(platform.value)),
    isIos: computed(() => platform.value === APP_WEBVIEW_PLATFORMS.ios),
    isAndroid: computed(() => platform.value === APP_WEBVIEW_PLATFORMS.android)
  };
}
